import createClient from 'openapi-react-query'
import type { Client } from 'openapi-fetch'

/**
 * Wraps an `openapi-fetch` client with `openapi-react-query` to provide
 * typed React Query hooks (`useQuery`, `useMutation`, `useSuspenseQuery`).
 *
 * @example
 * ```ts
 * import type { paths } from '@mdhp/api-client/schemas/main-api'
 *
 * const fetchClient = createApiClient<paths>({ baseUrl: '...' })
 * const api = createApiQueryClient(fetchClient)
 *
 * // In a component:
 * const { data } = api.useQuery('get', '/patients/{patient_id}', {
 *   params: { path: { patient_id: '123' } },
 * })
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- Paths must accept openapi-typescript's generated interfaces which lack a string index signature
export function createApiQueryClient<Paths extends {}>(fetchClient: Client<Paths>) {
  return createClient(fetchClient)
}
